import { SafePromise } from '@benzinga/safe-await';
import { ContentManager, Term } from '@benzinga/content-manager';
import { Session } from '@benzinga/session';
import { isExpiredUrlActive } from '../expiredUrlSlug';
import { ArticleManager } from '../manager';
import type { GetArticleI } from '../entities/article';

export const getArticleTerms = async (session: Session, article: GetArticleI): SafePromise<Term[]> => {
  const channels = article.Channels ? article.Channels : [];
  const tags = article.Tags ? article.Tags : [];
  const tids = [...new Set(channels.map(c => c.tid).concat(tags.map(t => t.tid)))];
  if (tids.length === 0) return { ok: [] };

  const contentManager = session.getManager(ContentManager);
  const articleManager = session.getManager(ArticleManager);
  const termRes = await contentManager.getTermById(tids.join(','));
  const terms = Array.isArray(termRes.ok) ? termRes.ok : [];

  const results = await Promise.allSettled(
    terms.map(async (term: Term) => {
      if (!term.url_public) {
        return term;
      }

      try {
        const expiredUrlCheck = await articleManager.checkExpiredUrl('topic', term.url_public);
        const isValid = !isExpiredUrlActive(expiredUrlCheck.ok);
        return isValid ? term : null;
      } catch (error) {
        console.error('Error checking expired URL for term:', term.url_public, error);
        return term;
      }
    }),
  );

  const validTerms = results
    .filter((result): result is PromiseFulfilledResult<Term> => result.status === 'fulfilled' && result.value !== null)
    .map(result => result.value);

  return {
    ok: validTerms,
  };
};
